import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/icons/company.svg'
import _imports_1 from '../../../../assets/icons/home-filled-icon.svg'
import _imports_2 from '../../../../assets/icons/id-check.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e8dc3dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "!tw-text-[20px] !tw-font-bold" }, "Select Workstation Type", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-title !tw-text-[14px] !tw-leading-[24px] !tw-mt-[.5rem]" }, " Please choose the type of workstation you would like to set up. You can either select 'Company' for a business account or 'Individual' for a personal account. ", -1))
const _hoisted_5 = { class: "modal_form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select_type__card-details" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "workstation_icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "select_type__icon",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "select_type__card-details__text" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Company")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select_type__card-details !tw-mt-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "select_type__card-details__icon workstation_icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "select_type__icon",
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "select_type__card-details__text" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Individual")
  ])
], -1))
const _hoisted_8 = { class: "modal_footer_button" }
const _hoisted_9 = { class: "modal_content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "We will require your passport or driver’s license."),
  /*#__PURE__*/_createElementVNode("p", null, " Verified ID is required to ensure trust security and compliance on Iknowa. ")
], -1))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "your-img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_2
  })
], -1))
const _hoisted_13 = ["loading"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewWorkstationSubscriptionModal = _resolveComponent("NewWorkstationSubscriptionModal")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_WorkstationVerificationModal = _resolveComponent("WorkstationVerificationModal")!
  const _component_KYCStatusModal = _resolveComponent("KYCStatusModal")!
  const _component_PaymentStatusModal = _resolveComponent("PaymentStatusModal")!
  const _component_PropertyOwnerTermsConditionModal = _resolveComponent("PropertyOwnerTermsConditionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowSubscriptionModal)
      ? (_openBlock(), _createBlock(_component_NewWorkstationSubscriptionModal, {
          key: 0,
          onOnClickPaymentPlan: $setup.onClickUpgradePremium,
          isLoading: $setup.paymentRedirectLoading,
          onCloseModal: $setup.onClickCloseButton,
          onOnClickTermsAndCondition: $setup.onClickTermsAndConditionModal,
          isProperty: true
        }, null, 8, ["onOnClickPaymentPlan", "isLoading", "onCloseModal", "onOnClickTermsAndCondition"]))
      : _createCommentVNode("", true),
    ($setup.isShowSelectWorkstationTypeModal)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 1,
          isShowHeader: false,
          isShowBackButton: false,
          className: ['select_workstation_type_modal'],
          width: "550px",
          height: "auto"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  onClick: $setup.onClickCloseSelectWorkstationTypeModalButton
                }, null, 8, ["onClick"])
              ]),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_card, {
                  class: _normalizeClass(["select_type__card-item", { selected: $setup.selectedType === 'Company' }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectType('Company')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_v_card, {
                  class: _normalizeClass(["select_type__card-item", { selected: $setup.selectedType === 'Individual' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectType('Individual')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  label: "Cancel",
                  onClick: $setup.onClickCloseSelectWorkstationTypeModalButton,
                  variant: "secondary",
                  class: "button"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  onClick: $setup.onClickContinueButton,
                  isActive: $setup.selectedType,
                  class: "button",
                  label: "Continue",
                  variant: "accent"
                }, null, 8, ["onClick", "isActive"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.isShowIDCheckModal)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 2,
          className: ['property_owner_id_Check_modal'],
          onClickBackButton: $setup.onClickCloseIDCheckButton,
          HeaderTittle: $setup.HeaderTittle,
          title: "We need to verify your identity",
          width: "650px",
          height: "auto"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                ($setup.isShowNextButton)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "button button-orange w-full"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Next")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.selectedType === 'Individual' || $setup.isKYCUnverified)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      loading: $setup.isLoading,
                      class: "btn_link !tw-w-full",
                      onClick: $setup.onClickKycTypeIdVerification
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Start ID verification ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                ($setup.selectedType === 'Company' && !$setup.isKYCUnverified)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      loading: $setup.isLoading,
                      class: "btn_link",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.onClickIdVerification && $setup.onClickIdVerification(...args)), ["prevent"]))
                    }, "Start ID verification", 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClickBackButton", "HeaderTittle"]))
      : _createCommentVNode("", true),
    ($setup.isOpenVerifyModal)
      ? (_openBlock(), _createBlock(_component_WorkstationVerificationModal, {
          key: 3,
          onClickCloseTab: $setup.toggleVerifyModal
        }, null, 8, ["onClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.statusModal.KYC === $setup.currentStatusModalName)
      ? (_openBlock(), _createBlock(_component_KYCStatusModal, {
          key: 4,
          onContinue: $setup.onClickTermAndConditionNext,
          kycStatus: $setup.currentModalStatus
        }, null, 8, ["onContinue", "kycStatus"]))
      : _createCommentVNode("", true),
    ($setup.statusModal.PAYMENT === $setup.currentStatusModalName)
      ? (_openBlock(), _createBlock(_component_PaymentStatusModal, {
          key: 5,
          onContinue: $setup.onClickStatusModalContinue,
          paymentStatus: $setup.currentModalStatus,
          planType: $setup.planType
        }, null, 8, ["onContinue", "paymentStatus", "planType"]))
      : _createCommentVNode("", true),
    ($setup.isShowTermsAndConditionModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerTermsConditionModal, {
          key: 6,
          onCloseTermsAndConditionModal: $setup.closeTermsAndConditionModal
        }, null, 8, ["onCloseTermsAndConditionModal"]))
      : _createCommentVNode("", true),
    ($setup.statusModal.KYBINFO == $setup.currentStatusModalName)
      ? (_openBlock(), _createBlock(_component_KYCStatusModal, {
          key: 7,
          onContinue: $setup.onClickCloseSelectWorkstationTypeModalButton,
          kycStatus: "KYBINFO"
        }, null, 8, ["onContinue"]))
      : _createCommentVNode("", true)
  ], 64))
}